import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "UpdateUserConfig" */ './lazyIndex')
);

export const lazyUpdateUserConfigurationService = new LazyAction(
    lazyModule,
    m => m.updateUserConfigurationService
);
